
define(
	'Ames.ExcludeItems.ExcludeItems'
	, [
		'SC.Configuration'
	]
	, function (
		Configuration
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var item = false;
				var excludedFacet = 'custitem60';

				// _.extend(Configuration.searchApiMasterOptions.Facets, {
				// 	'facet.exclude': excludedFacet, 'custitem60': item
				// });

				_.extend(Configuration.searchApiMasterOptions.itemsSearcher, {
					'facet.exclude': excludedFacet, 'custitem60': item
				});

				// _.extend(Configuration.searchApiMasterOptions.typeAhead, {
				// 	'facet.exclude': excludedFacet, 'custitem60': item
				// });

				_.extend(Configuration.searchApiMasterOptions.relatedItems, {
					'facet.exclude': excludedFacet, 'custitem60': item
				});

				_.extend(Configuration.searchApiMasterOptions.correlatedItems, {
					'facet.exclude': excludedFacet, 'custitem60': item
				});

				_.extend(Configuration.searchApiMasterOptions.itemDetails, {
					'facet.exclude': excludedFacet, 'custitem60': item
				});

			}
		};
	});
